import { Button } from "@fluentui/react-components";
import { ChatBubblesQuestionRegular } from "@fluentui/react-icons";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import i18n from "i18next";
import Header from "../Header";

function Faq(props: any) {
  const faqDe = (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={
                <ChatBubblesQuestionRegular fontSize={24} color="#ff6600" />
              }
              appearance="subtle"
            >
              FAQ
            </Button>
          </StackShim>
        }
      />

      <div className="lueb-ContentBlock">
        <h4 style={{ color: "#ff6600" }}>Allgemein</h4>
        <div style={{ margin: "15px" }}></div>
        <h5>
          Kann ich den Umbau eines LÜBBERING Schraubsystems in My Toolbox
          festhalten bzw. einsehen?
        </h5>
        <p>
          My Toolbox bildet zum aktuellen Zeitpunkt immer nur den
          Auslieferungszustand ab. Eine Erweiterung dieser Funktion ist in
          Bearbeitung.
        </p>
        <div style={{ margin: "25px" }}></div>
        <h4 style={{ color: "#ff6600" }}>Registrierung</h4>
        <div style={{ margin: "15px" }}></div>
        <h5>
          Was passiert mit meinen personenbezogenen Daten im Rahmen der
          Registrierung?
        </h5>

        <p>
          Ihre personenbezogenen Daten werden in unserer Nutzerdatenbank zum
          Zweck der Erstellung Ihres Benutzerkontos gespeichert. Sofern Sie auch
          dem Erhalt unserers Newsletters zugestimmt haben, nutzen wir Ihre
          E-Mail-Adresse, um Ihnen einen Newsletter zuzusenden. Eine Weitergabe
          Ihrer Daten an Dritte erfolgt nicht, es sei denn, Sie haben der
          Weitergabe ausdrücklich zugestimmt.
        </p>
        <div style={{ margin: "15px" }}></div>
        <h5>Wie kann ich meinen Account löschen?</h5>
        <p>
          Sie können Ihr Benutzerkonto löschen, indem Sie in Ihrem Profil die
          Schaltfläche "Löschung beantragen" betätigen. Ihre Daten werden dann
          schnellstmöglich von uns gelöscht.
        </p>
        <div style={{ margin: "25px" }}></div>
        <h4 style={{ color: "#ff6600" }}>Teams</h4>
        <div style={{ margin: "15px" }}></div>
        <h5>Wer ist der Teamadministrator?</h5>
        <p>
          Der Teamadministrator ist immer derjenige, der das Team erstellt hat.
        </p>
        <div style={{ margin: "15px" }}></div>
        <h5>Welche Aktionen kann ein Teamadministrator ausführen?</h5>
        <p>Ein Teamadministrator kann folgende Aktionen ausführen:</p>
        <ul className="lueb-listWithPlusIcon">
          <li>Neue Mitglieder in das Team einladen</li>
          <li>Team-Mitglieder aus dem Team löschen</li>
          <li>Eingeladene User aus der Einladungsliste löschen</li>
          <li>Team löschen</li>
          <li>Team editieren (z.B. Team-Name)</li>
        </ul>
        <div style={{ margin: "15px" }}></div>
        <h5>Was passiert mit meinen Teams, wenn ich meinen Account lösche?</h5>
        <p>
          Die Teams müssen an einen anderen Team-User übergeben werden. Sollte
          dies der Fall sein, werden wir mit Ihnen Kontakt aufnehmen.
        </p>
        <div style={{ margin: "15px" }}></div>
        <h5>Was bietet mir die Funktion eines Teams?</h5>
        <p>
          Sie haben die Möglichkeit, im Team auf ein Schraubsystem zuzugreifen
          und die Unterlagen zu Ihrem Schraubsystem zentral an einer Stelle
          einzusehen. Der Vorteil ist, dass ein Schraubsystem nur einmalig
          registriert werden muss und Ihr gesamtes Team Zugriff auf dieses
          Schraubsystem erhält. Zudem können Sie innerhalb eines Teams Bedarfe
          eines Ersatzteils direkt für Ihren Vorgesetzen oder dem Einkauf
          kenntlich machen.
        </p>
        <div style={{ margin: "15px" }}></div>
        <h5>Wie kann ich ein Schraubsystem für mein Team veröffentlichen?</h5>
        <p>Sie können Ihr Produkt für andere Teammitglieder freischalten.</p>
        <div style={{ margin: "25px" }}></div>
        <h4 style={{ color: "#ff6600" }}>Bedarfe</h4>
        <div style={{ margin: "15px" }}></div>
        <h5>Wie lange dauert die Bearbeitung einer Bedarfsanfrage?</h5>
        <p>
          Sie erhalten unser Angebot zu den von Ihnen angefragten Bedarfen
          werktags in der Regel binnen 48 Stunden.
        </p>
        <div style={{ margin: "15px" }}></div>
        <h5>Kann ich über meine Bedarfsübersicht eine Bestellung auslösen?</h5>
        <p>
          Nein, es wird keine Bestellung ausgelöst. Über die Bedarfsübersicht
          können Sie eine Anfrage an uns senden, zu der wir Ihnen dann ein
          entsprechendes Angebot unterbreiten werden.
        </p>
        <div style={{ margin: "25px" }}></div>
        <h4 style={{ color: "#ff6600" }}>L.SP3 Configurator</h4>
        <div style={{ margin: "15px" }}></div>
        <h5>
          Wie lange dauert die Bearbeitung einer Anfrage über den L.SP3
          Configurator?
        </h5>
        <p>
          Sofern alle erforderlichen Komponenten bereits konstruktiv vorhanden
          sind, erhalten Sie unser Angebot werktags in der Regel binnen 48
          Stunden.
        </p>
      </div>
    </div>
  );

  const faqEn = (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={
                <ChatBubblesQuestionRegular fontSize={24} color="#ff6600" />
              }
              appearance="subtle"
            >
              FAQ
            </Button>
          </StackShim>
        }
      />
      <div className="lueb-Headline">
        <h3>Frequently asked Questions (FAQ)</h3>
      </div>
      <div className="lueb-ContentBlock">
        <h4 style={{ color: "#ff6600" }}>General</h4>
        <div style={{ margin: "15px" }}></div>
        <h5>
          Will any modifications to a LÜBBERING fastening system be recorded in
          My Toolbox?
        </h5>
        <p>
          At this time, My Toolbox only shows the as-delivered configuration. We
          are currently developing this function.
        </p>
        ´<div style={{ margin: "25px" }}></div>
        <h4 style={{ color: "#ff6600" }}>Register</h4>
        <div style={{ margin: "15px" }}></div>
        <h5>What happens to my personal data when i register?</h5>
        <p>
          Your personal data will be stored in our database for the purpose of
          creating your user account. If you have agreed to receive our
          newsletters, your email address to sent you the newsletters. We will
          not transfer your data to third parties, unless you have explicitly
          consented to such a transfer in advance.
        </p>
        <div style={{ margin: "15px" }}></div>
        <h5>How can i delete my user account?</h5>
        <p>
          You can delete your account by clicking on "Request delete of account"
          in the my account menu. Your account will then be deleted as soon as
          possible.
        </p>
        <div style={{ margin: "25px" }}></div>
        <h4 style={{ color: "#ff6600" }}>Teams</h4>
        <div style={{ margin: "15px" }}></div>
        <h5>Who is the team administrator?</h5>
        <p>The team administrator is the person who has created the team.</p>
        <div style={{ margin: "15px" }}></div>
        <h5>What actions can a team administrator carry out?</h5>
        <p>A team administrator can carry out the following actions:</p>
        <ul>
          <li>invite new members into the team</li>
          <li>delete team members from the team</li>
          <li>delete invited users from the invitation list</li>
          <li>delete the team</li>
          <li>edit the team (e.g. change team name)</li>
        </ul>
        <div style={{ margin: "15px" }}></div>
        <h5>What happens to my teams if i delete my user account?</h5>
        <p>
          The teams will have to be allocated to another team member. If this is
          the case, we will contact you.
        </p>
        <div style={{ margin: "15px" }}></div>
        <h5>What are the benefits of being in a team?</h5>
        <p>
          In a team, you will have access to a fastening system and can view all
          the relevant documents centrally in one place. The advantage of this
          is that a fastening system only needs to be registered once and then
          your complete team has access to it. In addition, as part of a team,
          you can put articles on a list which your line manager / purchasing
          department can see.
        </p>
        <div style={{ margin: "15px" }}></div>
        <h5>How can i show a fastening system to my team?</h5>
        <p>You can activate a fastening system for members of your team.</p>
        <div style={{ margin: "25px" }}></div>
        <h4 style={{ color: "#ff6600" }}>Requirements</h4>
        <div style={{ margin: "15px" }}></div>
        <h5>How long does it take to process an inquiry?</h5>
        <p>
          You will receive an offer for the articles you have selected in your
          inquiry in general within 48 hours on weekdays.
        </p>
        <div style={{ margin: "15px" }}></div>
        <h5>Can i create an order from my requirements list?</h5>
        <p>
          An order cannot be created and sent from your requirements list. You
          can however send an inquiry, to which we will send you an offer.
        </p>
        <div style={{ margin: "25px" }}></div>
        <h4 style={{ color: "#ff6600" }}>L.SP3 Configurator</h4>
        <div style={{ margin: "15px" }}></div>
        <h5>
          How long does it take to process an inquiry sent from the
          configurator?
        </h5>
        <p>
          If no design work is required and all the technical articles are
          already in the system, you will receive an offer usually within 48
          hours on weekdays.
        </p>
      </div>
    </div>
  );

  return i18n.language.includes("de") ? faqDe : faqEn;
}

export default Faq;
